import React, { useEffect, useState, useRef } from "react"; // 🔥 useRef added
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { toast } from "react-toastify";

export const CrazyDeals = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [discounts, setDiscounts] = useState([]);

  const scrollRef = useRef(null); // 🔥 added
  const headRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // 🔹 Fetch categories
        const catRes = await axios.get(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_category"
        );
        if (catRes.data.status === true || catRes.data.status === "true") {
          setCategories(catRes.data.row);
        }

        // 🔹 Fetch discounts
        const discRes = await axios.get(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/discount_list"
        );
        if (discRes.data.status) {
          setDiscounts(discRes.data.data);
        }

        // 🔹 Fetch products
        const prodRes = await axios.get(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_create_product"
        );

        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) => item.product_status === "Crazy Deals" &&
                      item.admin_approval === "approval" &&
                      item.paid_approval === "yes"
          );

          setProducts(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }
      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };

    fetchAll();
  }, []);

  // ── Intersection Observer ──
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headRef.current) observer.observe(headRef.current);
    cardRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, [products]); // re-run after products load

  // Convert category_id → category_name
  const getCategoryName = (catId) => {
    const found = categories.find((c) => c.category_id === catId);
    return found ? found.category_name : "Unknown Category";
  };

  //  Convert disc_id → discount_amount
  const getDiscountAmount = (discId) => {
    const found = discounts.find((d) => d.disc_id === discId);
    return found ? found.disc_amount : "0";
  };

  // 🔥 scroll functions
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <div className="container my-4 bg-white">

      {/* Header */}
      <div
        className="d-flex justify-content-between align-items-center tp-head"
        ref={headRef}
      >
        <h3 className="fw-bold p-1">Crazy Deals</h3>
        <Link
          to="/products"
          state={{ categoryId: 2 }} // 🔥 Electronics ID
          className="text-decoration-none"
          style={{ color: "rgb(252, 146, 204)" }}
        >
          View All <i className="bi bi-chevron-right"></i>
        </Link>
      </div>

      {/* 🔥 wrapper added */}
      <div className="position-relative">

        {/* 🔥 prev button */}
        <button onClick={scrollLeft} className="scroll-btn left">‹</button>

        {/* 🔥 replaced row with scroll container */}
        <div
          ref={scrollRef}
          className="d-flex overflow-auto gap-3 px-2 top-picks-scroll"
        >
          {products.map((product, index) => (
            <div
              key={product.product_id}
              ref={(el) => (cardRefs.current[index] = el)}
              className="col-lg-2 col-md-3 col-sm-6 col-6 mb-4 d-flex flex-shrink-0 tp-card"
              style={{ width: "230px", "--delay": `${index * 70}ms` }} // 🔥 important
            >
              <div className="card flex-fill h-100 shadow-sm border rounded-3">
                <img
                  src={`https://cyberathon.com/multivendor/${product.multi_image?.[0]}`}
                  className="card-img-top p-3"
                  alt={product.product_name}
                />

              <div className="card-body">
                <h6 className="fw-bold mb-1">
                  {product.product_name?.split(" ").slice(0, 2).join(" ")}
                </h6>

                {/* <p className="text-muted small mb-1">
                  {getCategoryName(product.category_id)}
                </p> */}

                {/* <div className="d-flex align-items-center mb-2">
                  <span className="fw-semibold me-1">
                    {product.rating?.rating ?? "4.5"}
                  </span>
                  <span style={{ color: "#f5c518" }}>★</span>
                  <span className="text-dark ms-1 small">
                    | {product.rating?.rating ?? 100} Ratings
                  </span>
                </div> */}

                {/* <p
                  className={`fw-semibold mb-1 ${
                    (product.rating?.rating ?? 4.5) > 4
                      ? "text-success"
                      : "text-warning"
                  }`}
                >
                  {product.status}
                </p> */}

                <div className="price-new d-flex align-items-center gap-2 flex-wrap">
                  <h6 className="fw-bold mb-0">₹{product.current_price}</h6>

                  <small className="price-old text-muted text-decoration-line-through">
                    ₹{product.old_price}
                  </small>

                  {product.discount && (
                    <small className="text-danger fw-semibold">
                      ({product.discount}% OFF)
                    </small>
                  )}
                </div>

                <div className="mt-2 text-center">
                  <Link to={`/model/${product.product_id}`}>
                    <button type="submit" className="Addto-cart">
                      Add to bag
                    </button>
                  </Link>
                </div>
              </div>

            </div>
          </div>
        ))}
      </div>

      {/* 🔥 next button */}
      <button onClick={scrollRight} className="scroll-btn right">›</button>

    </div>
  </div>
);
};